"use client";

import { useEffect } from "react";
import { useBlogLocaleNavigation } from "@/components/layout/CcLocaleContext";
import type { BlogLocaleNavigation } from "@/lib/blog/locale-navigation";
import { localeFromPathname } from "@/lib/i18n/paths";

/** Layouts persist between articles; keep the footer's language targets on the current post. */
export function CcBlogLocaleNavigationSync({ navigation }: { navigation: BlogLocaleNavigation }) {
  const { setNavigation } = useBlogLocaleNavigation();
  useEffect(() => {
    setNavigation(navigation);
    document.documentElement.lang = navigation.lang;
    return () => {
      document.documentElement.lang = localeFromPathname(window.location.pathname);
      setNavigation((current) => current?.pathname === navigation.pathname ? null : current);
    };
  }, [navigation, setNavigation]);
  return null;
}
